import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";

import i18n from "i18n";
import styles from "./LoadBusiness.Wizard.Step3.module.scss";

const keyTitleMap = {
    name: 'Nombre',
    business_name: 'Razon Social',
    nif: 'Nif',
    sector: 'Rubro',
    country: 'Pais',
    region: 'Comunidad',
    state: 'Provincia',
    locality: 'Municipio',
    currency: 'Moneda',
    address: 'Direccion',
    phone: 'Telefono',
    email: 'Email',
}
export class AddConfigTagStepThree extends React.Component {
  render() {
    const { business, goBack, handleFinish } = this.props;

    const stepContent = (
      <form onSubmit={handleFinish}>
      <div className={styles["add-business-wizard-step-three-content"]}>
        <div className={styles["section"]}>
          <div className={styles["section-title"]}>{i18n.t("step.description")}</div>
          {
            ['name', 'business_name', 'nif', 'sector', 'country', 'region', 'state', 'locality', 'currency',].map(
              key => {
                return business[key] ? <div key={key}>
                  <div className={styles["title"]}> {keyTitleMap[key]} </div>
                  <div className={styles["value"]}> {business[key].label ? business[key].label : business[key]}</div>
                </div> : ''
              }
            )
          }
        </div>
        <div className={styles["section"]}>
          <div className={styles["section-title"]}>{i18n.t("step.image")}</div>
          <div className={styles["logo"]}>
<img src={business.image ? URL.createObjectURL(business.image) : undefined} />
          </div>
        </div>
        <div className={styles["section"]}>
          <div className={styles["section-title"]}>{i18n.t("contact")}</div>
          {
            ['address', 'phone', 'email'].map(
              key => {
                return business[key] ? <div key={key}>
                  <div className={styles["title"]}> {keyTitleMap[key]} </div>
                  <div className={styles["value"]}> {business[key]}</div>
                </div> : ''
              }
            )
          }
        </div>
        <div className={styles["add-business-wizard-step-three-action-wrapper"]}>
          <button type="submit" className={styles["add-business-wizard-step-three-action-button"]}>
            {i18n.t("finish").toUpperCase()}
          </button>
        </div>
      </div>
      </form>
    );

    return (
      <div className={styles["add-business-wizard-step-three-container"]}>
        <Step title={i18n.t("confirmation")} content={stepContent} goBackFunc={goBack}></Step>
      </div>
    );
  }
}

export default AddConfigTagStepThree;
